import axios from '@/request/http'; // 导入http中创建的axios实例
import base from '@/request/api/base'// 导入接口域名列表
//调查问卷-培训班级相关接口
;

const myAllWork = {
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/dcwj/planWj/page`, params);
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/dcwj/planWj/get/${params.id}`)
  },
  //保存修改
  save(params) {
    return axios.post(`${base.bs}/admin/dcwj/planWj/save`, params)
  },
  //保存修改
  update(params) {
    return axios.post(`${base.bs}/admin/dcwj/planWj/set`, params)
  },
  //根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/dcwj/planWj/del/${params.id}`)
  },
  //批量删除
  batchDel(params) {
    return axios.post(`${base.bs}/admin/dcwj/planWj/batchDel`,params)
  },
  //生成二维码
  createQrcode(params) {
    return axios.get(`${base.bs}/admin/dcwj/planWj/createQrcode/${params.id}`,{params:{width:params.width,height:params.height}})
  },
  //保存调查问卷
  saveWj(params) {
    return axios.post(`${base.bs}/txdcwj/saveWj`, params)
  },

  //保存调查问卷
  wjPlanInfo(params) {
    return axios.post(`${base.bs}/txdcwj/getInfo/${params.planId}`, null)
  },

  //导出教师问卷
  exportWjByTeacher(params) {
    return axios.post(`${base.bs}/admin/dcwj/planWj/exportWjByTeacher`, params,{responseType: 'blob'})
  },
}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/dcwj/planWj.js